{
  "alert": "تنبيه",
  "dismiss": "تجاهل"
}